import "./App.css";

export const App = () => {
  return (
    <div>
      <h1>Hello React with Vite</h1>
    </div>
  );
};
